import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { JoiTemplate } from 'globals/store/publish.data';
import { Attendee, attendeeProps } from 'globals/store/attendees.data';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { CustomQuestionsComponent } from 'src/app/components/entities/custom-questions.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs';

@Component({
    selector: 'share-edit-attendee-form',
    template: `
<div class="event-name ">{{ topTitle }}</div>
<div class="instructions body-text" *ngIf="!!instructions" [innerHTML]="instructions"></div>
<div class="top">
  <div class="photos">
    <image-uploader 
      #photoEditor 
      [id]="attendee.id || ''" 
      [publishCode]="publishCode"
      [public]="true"
      [photoUrl]="attendee.fullPhotoUrl" 
      [hints]="imageHints"
      [eventId]="eventId" 
      type="attendee" 
      subtype="photo" 
      placeholder="Add photo"
    ></image-uploader>
  </div>
  <div class="fields body-text">
    <mutating-input [object]="attendee" [prop]="props.name" placeholder="Attendee name"></mutating-input>
    <mutating-input [object]="attendee" [prop]="props.line1" hint="e.g. Job title" placeholder="Line 1" ></mutating-input>
    <mutating-input [object]="attendee" [prop]="props.line2" hint="e.g. Company" placeholder="Line 2" ></mutating-input>
    <mutating-input [object]="attendee" [prop]="props.email" [placeholder]="'Attendee contact email'" ></mutating-input>
    <mutating-input [object]="attendee" [prop]="props.phone" [placeholder]="'Attendee contact phone'" ></mutating-input>
    <h5>Attendee contact address</h5>
    <input-editor 
      class="placeholder-no-italics"
      [object]="attendee" 
      [forceSave]="forceSave" 
      [prop]="'contactFullAddress'" 
      [placeholder]="'Attendee contact address...'"
    ></input-editor>
    <add-manage-wrapper class="social-open" [hideHRule]="true" wrapperTitle="SOCIAL" [openLabel]="!attendee.social?.length ? '+ ADD A SOCIAL LINK' : 'MANAGE SOCIAL LINKS'" (open)="openSocialLinks($event, attendee)">
      <social-links *ngIf="attendee?.social?.length" [socialLinks]="attendee.social || []"></social-links>
    </add-manage-wrapper>
  </div>
</div>
<div class="bottom">
  <custom-questions class="body-text"
    [entity]="attendee"
    [questions]="customQuestions"
    [shareView]="true"
    (updateQuestion)="updateCustomQuestion($event, attendee)"
  ></custom-questions>

  <button mat-button color="primary" (click)="submit()" [disabled]="processing || photoEditor.imageChanging" >
    <div class="button_content">
      Submit
      <loader icon="button_wheel"></loader>
    </div>
  </button>
  <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
</div>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, LoaderComponent, CustomQuestionsComponent, SocialLinksComponent, AddManageWrapperComponent, MutatingInputComponent, InputEditorComponent, ImageUploaderComponent ],
})
export class AttendeeEditProfileComponent extends ShareWrapper<AttendeeEditProfileComponent> {
    @ViewChild('photoEditor') photoEditor
    props = attendeeProps
    @Input() topTitle: string
    @Input() eventId: string
    @Input() attendee: Attendee
    @Input() publishCode // in the case of 
    @Input() customQuestions: CustomQuestion[] = []
    @Input() error
    @Input() processing: boolean
    @Input() callToSubmit: boolean
    @Input() instructions: string
    @Input() template: JoiTemplate
    showMandatoryWarnings = false;
    forceSave: Subject<void> = new Subject<void>(); 
    
    
    @Output() onSubmit: EventEmitter<Attendee> = new EventEmitter()


    async submit() {
      // CHECK FOR MANDATORY FIELDS
      this.forceSave.next();
      const allRequirementsCompleted = await this.publicService.checkForMandatory(this.customQuestions, this.attendee.customQuestions);
      if(!allRequirementsCompleted) {
        this.showMandatoryWarnings = true;
        return;
      }
      if (this.photoEditor.deleteDeletedPhotos()) {
        this.attendee.photoUrl = this.photoEditor.tempThumbUrl
        this.attendee.fullPhotoUrl = this.photoEditor.tempUrl

      }
      this.onSubmit.emit(this.attendee)
    }
}

